import * as React from 'react';

import {
  CiriumLogoDarkIcon,
  Text,
} from '@flightstats/airframe-react';

type PoweredByCiriumProps = React.ComponentProps<typeof Text>;

export const PoweredByCirium: React.FC<PoweredByCiriumProps> = ({ ...rest }) => (
  <Text variant="h100" paddingTop="32px" {...rest}>
   POWERED BY <CiriumLogoDarkIcon height="20px" width="70px" />
  </Text>
);